import React, { useMemo } from 'react';
import { Row, Table } from 'react-bootstrap';
import { getCurrentStyle } from '../../../helpers/passport';
import { ORANGE_COLOR_PASSPORT } from '../../../utils/consts';
import IndicatorsDataTable from './IndicatorsDataTable';
import moment from 'moment';
import { divideDataForActive, divideNonFixedForActive, indicatorsActiveType, indicatorsType } from '../../../helpers/indicators';

const IndicatorsTable = ({
  years,
  mappedPcs,
  data,
  mappedAcceptedData,
  type
}) => {

  const {
    activeMappedPcs,
    activeMappedAcceptedPcs
  } = useMemo(() => {
    return {
      activeMappedPcs: type === indicatorsType.fixed ? divideDataForActive(mappedPcs) : divideNonFixedForActive(mappedPcs),
      activeMappedAcceptedPcs: type === indicatorsType.fixed ? divideDataForActive(mappedAcceptedData) : divideNonFixedForActive(mappedAcceptedData)
    };
  }, [mappedPcs, mappedAcceptedData]);

  return (
    <React.Fragment>
      <p style={{
        color: ORANGE_COLOR_PASSPORT,
        fontWeight: 600,
        fontSize: 18
      }}>{type}</p>
      <Row>
        <Table striped className="read-view">
          <thead>
          <tr>
            <th>Наименование показателя</th>
            <th>Единицы измерения</th>
            {years.map((year) => <th key={year}>{year}</th>)}
            <th>Ключевой</th>
          </tr>
          </thead>
          <tbody>

          <IndicatorsDataTable data={data} type={indicatorsActiveType.active} years={years} sortedAcceptedPcs={activeMappedAcceptedPcs.active} sortedPcs={activeMappedPcs.active}/>
          {activeMappedPcs.notActive?.length > 0 && <IndicatorsDataTable data={data} type={indicatorsActiveType.notActive} years={years} sortedAcceptedPcs={activeMappedAcceptedPcs.notActive} sortedPcs={activeMappedPcs.notActive}/>}
          </tbody>
        </Table>
      </Row>
    </React.Fragment>
  );
};

export default IndicatorsTable;
